import { render, staticRenderFns } from "./NewCapturePage.vue?vue&type=template&id=253d5422"
import script from "./NewCapturePage.vue?vue&type=script&lang=js"
export * from "./NewCapturePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports